import styled from 'styled-components'

export const Summary = styled.span`
	display: flex;
	flex-wrap: wrap;
	align-items: baseline;
	gap: 4px 8px;
	min-width: 0;
`
